import { render, staticRenderFns } from "./ManagePromotion.vue?vue&type=template&id=1a53cbc2&"
import script from "./ManagePromotion.vue?vue&type=script&lang=js&"
export * from "./ManagePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports